import { Form, FormInstance, Modal, Upload } from 'antd';
import type { RcFile, UploadFile } from 'antd/es/upload/interface';
import { PdfView } from 'presentation/components/pdf/pdfview';
import { useEffect, useState } from 'react';
import { FILE_TYPE } from 'utilities/constants/COMMON';
//fallback
interface props {
    initialImageUrl?: string | undefined;
    form?: FormInstance;
    existedFile?: any;
    imageId?: number;
    initFile?: UploadFile[];
}

const getBase64Preview = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });
const UploadImage = ({ initFile }: props) => {
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [fileType, setFileType] = useState('');
    useEffect(() => {
        if (initFile) {
            setFileList(initFile);
        }
    }, [initFile]);

    const dummyRequest = ({ file, onSuccess }: any) => {
        setTimeout(() => {
            onSuccess('ok');
        }, 0);
    };

    const onPreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64Preview(file.originFileObj as RcFile);
        }
        if (file.name?.endsWith('.pdf')) {
            setFileType(FILE_TYPE.PDF);
        } else {
            setFileType(FILE_TYPE.IMAGE);
        }
        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
    };
    const handleCancel = () => setPreviewOpen(false);
    return (
        <>
            <Form.Item name="image" style={{ margin: 0, padding: 0 }}>
                <Upload
                    className="upload-custom button-style hide-upload"
                    name="avatar"
                    listType="picture"
                    showUploadList={true}
                    customRequest={dummyRequest}
                    onPreview={onPreview}
                    fileList={fileList}
                    defaultFileList={initFile}
                ></Upload>
            </Form.Item>
            <Modal
                open={previewOpen}
                footer={null}
                onCancel={handleCancel}
                width={800}
                style={{
                    maxHeight: 'calc(100vh - 110px)',
                    overflow: 'auto',
                    paddingBottom: 'unset',
                }}
            >
                {fileType == FILE_TYPE.IMAGE && (
                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                )}
                {fileType == FILE_TYPE.PDF && (
                    <PdfView
                        source={previewImage}
                        renderAnnotationLayer={false}
                        renderTextLayer={false}
                        width={760}
                    />
                )}
            </Modal>
        </>
    );
};

export default UploadImage;
